import React from 'react'
import { SignupBanner } from 'components/SignupBanner'

export const MaintenanceWarning = ({ maintenanceString }) => {
  return (
    <SignupBanner>
      <SignupBanner.Description>{maintenanceString}</SignupBanner.Description>
    </SignupBanner>
  )
}
